import React from "react";
import PropTypes from "prop-types";
import { Button, Tooltip } from "@mui/material";
import { Icon } from "@iconify/react";
import { PRIMARY_ACTION_BUTTON_SX } from "./cardConstants";

export default function PrimaryDetailAction({ onDetail }) {
  return (
    <Tooltip
      title="Kommentare lesen/schreiben, hochgeladene Bilder einsehen, Bildfreigabe der Teilnehmer prüfen"
      placement="top"
    >
      <Button
        fullWidth
        variant="contained"
        onClick={onDetail}
        startIcon={<Icon icon="mdi:information-outline" />}
        sx={PRIMARY_ACTION_BUTTON_SX}
      >
        Details & Kommentare
      </Button>
    </Tooltip>
  );
}

PrimaryDetailAction.propTypes = {
  onDetail: PropTypes.func,
};

PrimaryDetailAction.defaultProps = {
  onDetail: undefined,
};
